<template>
  <el-switch
    v-bind="$attrs"
    class="rt-switch"
    v-on="$listeners"
  />
</template>

<script>
import ElSwitch from 'vue-xpc/src/element-ui/packages/switch';

export default {
  name: 'RtSwitch',
  components: { ElSwitch }
}
</script>



// WEBPACK FOOTER //
// rtSwitch.vue?24eedce4